export const USP_MATERIALS_NDS_GRID_MIN_WIDTH_PX = 1180;

export const USP_MATERIALS_NDS_GRID_COLS = [
  { key: "title", label: "Проект / Конструктив / Ресурс", width: "28rem", align: "left" },
  { key: "unit", label: "ед", width: "3.5rem", align: "left" },
  { key: "qty", label: "Кол-во", width: "5.5rem", align: "right" },
  { key: "price_with", label: "Цена с НДС", width: "6.5rem", align: "right" },
  { key: "sum_with", label: "Сумма с НДС", width: "7.5rem", align: "right" },
  { key: "price_without", label: "Цена без НДС", width: "6.5rem", align: "right" },
  { key: "sum_without", label: "Сумма без НДС", width: "7.5rem", align: "right" },
  { key: "nds_amount", label: "Сумма НДС", width: "6.5rem", align: "right" },
  { key: "nds_share", label: "Доля НДС (%)", width: "5.5rem", align: "right" },
];
